<template>
  <div class="search-box">
    <input
      type="text"
      v-model="searchQuery"
      placeholder="Search..."
      @keyup.enter="performSearch"
    />
    <button @click="performSearch">
      <i class="fa fa-search"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SearchBox',
  data() {
    return {
      searchQuery: '',
    };
  },
  methods: {
    performSearch() {
      if (this.searchQuery.trim() !== '') {
        // Navigate to the Search page with query parameter
        this.$router.push({ name: 'Search', query: { q: this.searchQuery } });
        // Clear the search input if needed
        // this.searchQuery = '';
      }
    },
  },
};
</script>

<style scoped>
/* Add styles for the search box */
.search-box {
  display: flex;
  align-items: center;
}

.search-box input {
  padding: 5px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.search-box button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  margin-left: 5px;
}

.search-box button i {
  font-size: 16px;
  color: #333;
}
</style>